import { API_PATH, HTTP_OK } from "@app/common/constants";
import {
  announcementStateActions,
  fetchDivisionsForAnnouncementTypeName,
  fetchRolesForAnnouncementTypeName,
  fetchMessageReOccurenceForAnnouncementTypeName,
  addAnnouncementCreatorTypeName,
  fetchAllAnnouncementsCreatorTypeName,
  fetchHistoricalAnnouncementsCreatorTypeName,
  fetchSingleAnnouncementCreatorTypeName,
  abortAnnouncementCreatorTypeName,
  updateAnnouncementCreatorTypeName
} from "./slice";
import { call, put, takeLatest } from "redux-saga/effects";
import NetworkService from "@app/services/network/NetworkService";
import { ToasterService } from "@app/services";
import { ToastType } from "@app/services/toaster";
// announcement banner

/* WATCHERS */
/**
 * Fetch Divisions List Watcher
 */
export function* fetchAnnouncementDivisionListWatcher() {
  yield takeLatest(
    fetchDivisionsForAnnouncementTypeName,
    fetchAnnouncementDivisionListWorker,
  );
};

/**
 * Fetch Roles List Watcher
 */
export function* fetchAnnouncementRoleListWatcher() {
  yield takeLatest(
    fetchRolesForAnnouncementTypeName,
    fetchAnnouncementRoleListWorker,
  );
};

/* Fetch Message ReOccurence List Worker*/
export function* fetchMessageReOccurenceForAnnouncementListWatcher() {
  yield takeLatest(
    fetchMessageReOccurenceForAnnouncementTypeName,
    fetchMessageReOccurenceForAnnouncementListWorker
  );
}

/* Add Announcement Watcher */
export function* addAnnouncementWatcher() {
  yield takeLatest(
    addAnnouncementCreatorTypeName, addAnnouncementWorker
  );
}

/* Fetch All Announcement List Watcher*/
export function* fetchAllAnnouncementsWatcher() {
  yield takeLatest(
    fetchAllAnnouncementsCreatorTypeName, fetchAllAnnouncementsWorker
  );
}

/* Fetch all historical announcements watcher */
export function* fetchHistoricalAnnouncementsWatcher() {
  yield takeLatest(
    fetchHistoricalAnnouncementsCreatorTypeName, fetchAllHistoricalAnnouncementsWorker
  );
}

/* Fetch Single Announcement watcher */
export function* fetchSingleAnnouncementWatcher(){
  yield takeLatest(
    fetchSingleAnnouncementCreatorTypeName,
    fetchSingleAnnouncementWorker
  )
}

/* Abort Announcement Watcher*/
// abortAnnouncementCreatorTypeName
export function* abortAnnouncementWatcher(){
  yield takeLatest(
    abortAnnouncementCreatorTypeName,
    abortAnnouncementWorker
  )
}
export function* updateAnnouncementWatcher() {
  yield takeLatest(
    updateAnnouncementCreatorTypeName, updateAnnouncementWorker
  );
}
/* WORKERS */
/**
 * Fetch Divisions List Worker
 */
export function* fetchAnnouncementRoleListWorker(): any {
  try {
    const url = API_PATH.moduleSpecificUtilities.orgPolicy.getAnnounceRoleList;
    yield put(announcementStateActions.setAnnouncementDivisonsLoading(true));
    const response = yield call(NetworkService.get, url, {}, {});
    // yield put(dcrUnlockRequestStateActions.setDCRUnlockReasons(response?.data));
    if (response.status === HTTP_OK) {
      yield put(announcementStateActions.setAnnouncementRoles(response?.data));
      yield put(announcementStateActions.setAnnouncementDivisonsLoading(false));
    } else {
      ToasterService.showToaster(
        'Something went wrong while fetching data',
        ToastType.ERROR,
      );
      yield put(announcementStateActions.setAnnouncementDivisonsLoading(false));
    }
  } catch (error) {
    ToasterService.showToaster(
      'Something went wrong while fetching data',
      ToastType.ERROR,
    );
    yield put(announcementStateActions.setAnnouncementDivisonsLoading(false));
    console.log(error);
  }
}

/* Fetch Role List Worker*/
export function* fetchAnnouncementDivisionListWorker(): any {
  try {
    const url = API_PATH.moduleSpecificUtilities.orgPolicy.getAnnounceDivisionList;
    const response = yield call(NetworkService.get, url, {}, {});
    // yield put(dcrUnlockRequestStateActions.setDCRUnlockReasons(response?.data));
    if (response.status === HTTP_OK) {
      yield put(announcementStateActions.setAnnouncementDivisons(response?.data));
    } else {
      ToasterService.showToaster(
        'Something went wrong while fetching data',
        ToastType.ERROR,
      );
    }
  } catch (error) {
    ToasterService.showToaster(
      'Something went wrong while fetching data',
      ToastType.ERROR,
    );
    console.log(error);
  }
}

/* Fetch Message ReOccurence List Worker*/
export function* fetchMessageReOccurenceForAnnouncementListWorker(): any {
  try {
    const url = API_PATH.moduleSpecificUtilities.orgPolicy.getannouncmentreoccurence;
    const response = yield call(NetworkService.get, url, {}, {});
    // yield put(dcrUnlockRequestStateActions.setDCRUnlockReasons(response?.data));
    if (response.status === HTTP_OK) {
      yield put(announcementStateActions.setMessageOccurence(response?.data));
    } else {
      ToasterService.showToaster(
        'Something went wrong while fetching data',
        ToastType.ERROR,
      );
    }
  } catch (error) {
    ToasterService.showToaster(
      'Something went wrong while fetching data',
      ToastType.ERROR,
    );
    console.log(error);
  }
}

/* Add Announcement Worker */
export function* addAnnouncementWorker(action: any): any {
  try {
    const url = API_PATH.moduleSpecificUtilities.orgPolicy.addannouncement;
    const response = yield call(NetworkService.post, url, action.payload);
    if (response.status === HTTP_OK) {
      if (!response.data.isCreated) {
        yield put(announcementStateActions.setAddAnnouncementResponse(null));
        return ToasterService.showToaster(
          `${response.data.message}`,
          ToastType.ERROR,
        );
      }
      yield put(
        announcementStateActions.setAddAnnouncementResponse({
          status: response?.data,
        }),
      );
      yield put(announcementStateActions.setSelectedTab(2));
      yield put(announcementStateActions.setIsRelaunchInitiated(false));
      return ToasterService.showToaster(
        `Announcement added successfully`,
        ToastType.SUCCESS,
      );
    } else if (response.status !== HTTP_OK) {
      yield put(announcementStateActions.setAddAnnouncementResponse(null));
      return ToasterService.showToaster(
        `${response?.data.error}`,
        ToastType.ERROR,
      );
    }
  } catch (error: any) {
    if (error.message) {
      ToasterService.showToaster(
        `${error.message}`,
        ToastType.ERROR,
      );
      yield put(announcementStateActions.setAddAnnouncementResponse(null));
    }

  }
}

/* Fetch All Announcement List Worker*/
export function* fetchAllAnnouncementsWorker(action: any): any {
  try {
    const url = API_PATH.moduleSpecificUtilities.orgPolicy.allAnnouncements;
    yield put(announcementStateActions.setAnnouncementDivisonsLoading(true));
    const response = yield call(NetworkService.get, url, {}, action.payload);
    // yield put(dcrUnlockRequestStateActions.setDCRUnlockReasons(response?.data));
    if (response.status === HTTP_OK) {
      yield put(announcementStateActions.setAllAnnouncements(response?.data));
      yield put(announcementStateActions.setAnnouncementDivisonsLoading(false));
    } else {
      ToasterService.showToaster(
        'Something went wrong while fetching data',
        ToastType.ERROR,  
      );
      yield put(announcementStateActions.setAnnouncementDivisonsLoading(false));
    }
  } catch (error) {
    ToasterService.showToaster(
      'Something went wrong while fetching data',
      ToastType.ERROR,
    );
    yield put(announcementStateActions.setAnnouncementDivisonsLoading(false));
    console.log(error);
  }
}

/*Fetch all historical announcements worker*/
export function* fetchAllHistoricalAnnouncementsWorker(action: any): any {
  try {
    const url = API_PATH.moduleSpecificUtilities.orgPolicy.getannouncementhistory;
    yield put(announcementStateActions.setHistoricalAnnouncementsListLoading(true));
    const response = yield call(NetworkService.post, url, action.payload);
    if (response.status === HTTP_OK) {
      if(response?.data.length === 0){
        ToasterService.showToaster(
          'No announcement found with the provided data, please change the selected values',
          ToastType.WARNING,
        );
      }
      yield put(announcementStateActions.setHistoricalAnnouncementsList(response?.data));
      yield put(announcementStateActions.setHistoricalAnnouncementsListLoading(false));
    } else {
        ToasterService.showToaster(
            'Something went wrong while fetching data',
            ToastType.ERROR,
          );
          yield put(announcementStateActions.setHistoricalAnnouncementsListLoading(false));
        }
      } catch (error) {
        ToasterService.showToaster(
      'Something went wrong while fetching data',
      ToastType.ERROR,
    );
    yield put(announcementStateActions.setHistoricalAnnouncementsListLoading(false));
    // yield put(announcementStateActions.setAnnouncementDivisonsLoading(false));
    console.log(error);
  }
};

/* Fetch Single Announcement Worker */
export function* fetchSingleAnnouncementWorker(action:any): any{
  try {
    const url = `${API_PATH.moduleSpecificUtilities.orgPolicy.getannouncementdetail}?announcementId=${action.payload}`;
    yield put(announcementStateActions.setAnnouncementDivisonsLoading(true));
    const response = yield call(NetworkService.get, url, {}, {});
    if (response.status === HTTP_OK) {
      yield put(announcementStateActions.setSingleAnnouncementDetail(response?.data));
      yield put(announcementStateActions.setAnnouncementDivisonsLoading(false));
    } else {
      ToasterService.showToaster(
        'Something went wrong while fetching data',
        ToastType.ERROR,  
      );
      yield put(announcementStateActions.setAnnouncementDivisonsLoading(false));
    }
  } catch (error) {
    ToasterService.showToaster(
      'Something went wrong while fetching data',
      ToastType.ERROR,
    );
    yield put(announcementStateActions.setAnnouncementDivisonsLoading(false));
    console.log(error);
  }
}
/* Abort Announcement Worker */
export function* abortAnnouncementWorker(action:any): any{
  try {
    const url = API_PATH.moduleSpecificUtilities.orgPolicy.updateannouncement; //updateannouncement
    const response = yield call(NetworkService.put, url, action.payload);
    if (response.status === HTTP_OK) {
      yield put(
        announcementStateActions.setAbortAnnouncementResponse({
          status: true,
        }),
      );
      ToasterService.showToaster(
        'Announcement aborted successfully',
        ToastType.SUCCESS,  
      );
      // yield put(announcementStateActions.setAnnouncementDivisonsLoading(false));
    } else{
      yield put(announcementStateActions.setAbortAnnouncementResponse(null));
      ToasterService.showToaster(
        'Announcement aborted failed, please try again later',
        ToastType.ERROR,  
      );
    }
  } catch (error) {
    yield put(announcementStateActions.setAbortAnnouncementResponse(null));
    ToasterService.showToaster(
      'Announcement aborted failed, please try again later',
      ToastType.ERROR,  
    );
  }
}

/* Update Announcement Worker */
export function* updateAnnouncementWorker(action: any): any {
  try {
    const url = API_PATH.moduleSpecificUtilities.orgPolicy.updateannouncement;
    const response = yield call(NetworkService.put, url, action.payload);
    if (response.status === HTTP_OK) {
      if (!response.data.isCreated) {
        yield put(announcementStateActions.setUpdateAnnouncementResponse(null));
        return ToasterService.showToaster(
          `${response.data.message}`,
          ToastType.ERROR,
        );
      }
      yield put(
        announcementStateActions.setUpdateAnnouncementResponse({
          status: response?.data,
        }),
      );
      yield put(announcementStateActions.setSelectedTab(2));
      yield put(announcementStateActions.setIsRelaunchInitiated(false));
      return ToasterService.showToaster(
        `Announcement updated successfully`,
        ToastType.SUCCESS,
      );
    } else if (response.status !== HTTP_OK) {
      yield put(announcementStateActions.setUpdateAnnouncementResponse(null));
      return ToasterService.showToaster(
        response?.data.error ? `${response?.data.error}`: "Something went wrong please try again later !!",
        ToastType.ERROR,
      );
    }
  } catch (error: any) {
    if (error.message) {
      ToasterService.showToaster(
        error ? `${error.message}` : "Something went wrong please try again later !!",
        ToastType.ERROR,
      );
      yield put(announcementStateActions.setAddAnnouncementResponse(null));
    }

  }
}




